
import { LanguageTexts } from '../types'

export const Text: LanguageTexts = {
  es: {
    'OrdTitle': 'Órdenes',
    'OrdFindText': '',
    'OrdFilterText': '',
    'OrderField': 'Número de orden',
    'OrdPanelOrder': 'Datos de la orden',
    'OrdPanelPatient': 'Paciente',
    'OrdAttachments': 'Adjuntos',
    'OrdNotes': 'Notas',
    'OrdClinicalData':'Datos clínicos',
    'OrdInformedConsents':'Consentimientos',
    'OrdNumHelpTextAuthomatic': 'Generado automáticamente',
    'OrdNumHelpTextManual': 'Ingrese el consecutivo',
    'OrdResults': 'Resultados',
    'OrdSerumLibrary': 'Seroteca',
    'OrdStudies': 'Estudios',
    'OrdTracking': 'Tracking',
    "OrdNoDataTitle": 'Ninguna orden seleccionada',
    "OrdNoDataDescription": 'Por favor, seleccione una orden para ver información detallada.',
    'OrdEstAdd': 'Estudios',
    'OrdProfilesAdd': 'Perfiles',
    'OrdEstudyGridArea': 'ÁREA',
    'OrdEstudyGridState': 'ESTADO',
    'OrdEstudyGridCode': 'CÓDIGO',
    'OrdEstudyGridStudyName': 'ESTUDIO',
    'OrdEstudyGridForwarded': 'REMITIDO',
    'OrdEstudyGridAddedFirst': 'El elemento',
    'OrdEstudyGridAddedSecond': 'ya ha sido agregado.',
    'OrdEstudyGridProfileGroup': 'PERFIL',
    'OrdInvoiceItem': 'Facturar ítem',
    'OrdDeleteSelectedStudy': 'Eliminar estudio seleccionado',
    'OrdMarkSelectedStudyAsReceived': 'Fijar estudio seleccionado como recibido',
    'OrdMarkSelectedStudyAsPending': 'Fijar estudio seleccionado como pendiente',
    'OrdPrintBarcode': 'Imprimir etiqueta de código de barras',
    'OrdReferSelectedStudy': 'Remisionar estudio seleccionado',
    'OrdViewAdditionalInfForStudy': 'Ver información adicional para estudio seleccionado',
    'OrdTotalStudiesAdded': 'Total estudios',
    'OrdLeavePending': 'Ha salido de la pantalla de órdenes sin guardar los cambios realizados',
    'OrdNotificationType': 'ORDEN',
    'OrdNotificationPatientReq': 'Debe especificar un paciente.',
    'OrdNotificationStudieReq': 'Debe añadir al menos un estudio.',
    'OrdModalOrdEstRpm': 'Información adicional por estudio',
    'OrdImported': 'Orden importada',
    'OrdNewNote':'Nueva nota',
    'OrdNewNoteError':'Ha ocurrido un error al registrar la nota, verifique la información e intente nuevamente',
    'OrdSuccessAction':'Acción ejecutada con éxito.',
    'OrdEditOrdDeny':'No cuenta con permisos para editar esta orden.',
    'OrdConfirmationReferStudyTemporaly':'Desea remitir este estudio de forma temporal'

  },
  en: {
    'OrdTitle': 'Orders',
    'OrdFindText': '',
    'OrdFilterText': '',
    'OrderField': 'Order number',
    'OrdPanelOrder': 'Order data',
    'OrdPanelPatient': 'Patient data',
    'OrdAttachments': 'Attachments',
    'OrdNotes': 'Notes',
    'OrdClinicalData':'Clinical data.',
    'OrdInformedConsents':'Informed consents',
    'OrdNumHelpTextAuthomatic': 'Automatically generated sequence number',
    'OrdNumHelpTextManual': 'Enter the order number',
    'OrdResults': 'Results',
    'OrdSerumLibrary': 'Serum library',
    'OrdStudies': 'Studies',
    'OrdTracking': 'Tracking',
    "OrdNoDataTitle": 'No order selected',
    "OrdNoDataDescription": 'Please select an order to view detailed information.',
    'OrdEstAdd': 'Estudies',
    'OrdProfilesAdd': 'Profiles',
    'OrdEstudyGridArea': 'AREA',
    'OrdEstudyGridState': 'STATE',
    'OrdEstudyGridCode': 'ID',
    'OrdEstudyGridStudyName': 'EXMAN',
    'OrdEstudyGridForwarded': 'FORWARDED',
    'OrdEstudyGridAddedFirst': 'The item',
    'OrdEstudyGridAddedSecond': 'has already been added.',
    'OrdEstudyGridProfileGroup': 'PROFILE',
    'OrdInvoiceItem': 'Invoice item',
    'OrdDeleteSelectedStudy': 'Delete selected study',
    'OrdMarkSelectedStudyAsReceived': 'Mark selected study as received',
    'OrdMarkSelectedStudyAsPending': 'Mark selected study as pending',
    'OrdPrintBarcode': 'Print barcode label',
    'OrdReferSelectedStudy': 'Refer selected study',
    'OrdViewAdditionalInfForStudy': 'View additional information for selected study',
    'OrdTotalStudiesAdded': 'Total studies',
    'OrdLeavePending': 'You\'ve exited the orders screen without saving your changes.',
    'OrdNotificationType': 'ORDER',
    'OrdNotificationPatientReq': 'You must specify a patient.',
    'OrdNotificationStudieReq': 'You must add at least one study.',
    'OrdModalOrdEstRpm': 'Additional information per study.',
    'OrdImported': 'Order imported',
    'OrdNewNote':'New Note',
    'OrdNewNoteError':'An error occurred while registering the note, please verify the information and try again',
    'OrdSuccessAction':'Action executed successfully.',
    'OrdEditOrdDeny':'You do not have permission to edit this order.',
    'OrdConfirmationReferStudyTemporaly':'Do you want to refer this study temporarily'
  }
};